import { Badge } from '@chakra-ui/react'

export const SignRequiredBadge: React.FC = () => {
  return (
    <Badge
      colorScheme="green"
      borderRadius="full"
      fontSize="xx-small"
      px="2"
      py="0.5"
      bg="green.100"
      color="green.600"
    >
      同意必須
    </Badge>
  )
}
